// API from: https://developers.google.com/youtube/iframe_api_reference
export const YOUTUBE_STATE_CHANGE = {
  UN_STARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  VIDEO_CUED: 5
}
